import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import MediaQuery from 'react-responsive';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';
import PlusIcon from '../../../../images/icons/plus-bold.svg';
import MinusIcon from '../../../../images/icons/minus-bold.svg';
import styles from './Store.module.sass';

const DESKTOP_WIDTH_BREAKPOINT = 750;
class Store extends Component {
  constructor(props) {
    super(props);
    const { isOpened } = props;
    this.state = { isOpened };
  }

  toggleIsOpened = () => {
    this.setState((prevState) => ({
      isOpened: !prevState.isOpened,
    }));
  };

  render() {
    const { store } = this.props;
    const { name, full_address: fullAddress, working_hours: workingHours } = store;
    const { isOpened } = this.state;
    return (
      <div className={styles.store}>
        <MediaQuery query={`(max-width: ${DESKTOP_WIDTH_BREAKPOINT - 1}px)`}>
          <ClickableDiv className={styles.head} onClick={this.toggleIsOpened}>
            <img src={`${isOpened ? MinusIcon : PlusIcon}`} alt={isOpened ? 'close' : 'open'} />
            <span className={styles.name}>
              { name }
            </span>
          </ClickableDiv>
          <AnimateHeight className={styles.content} duration={400} height={isOpened ? 'auto' : 0}>
            <div className={styles.address}>
              { fullAddress }
            </div>
            <div className={styles['working-hours']} dangerouslySetInnerHTML={{ __html: workingHours }} />
          </AnimateHeight>
        </MediaQuery>
        <MediaQuery query={`(min-width: ${DESKTOP_WIDTH_BREAKPOINT}px)`}>
          <div className={styles.name}>
            { name }
          </div>
          <div className={styles.address}>
            { fullAddress }
          </div>
          <div className={styles['working-hours']} dangerouslySetInnerHTML={{ __html: workingHours }} />
        </MediaQuery>
      </div>
    );
  }
}

Store.propTypes = {
  isOpened: PropTypes.bool,
  store: PropTypes.shape({
    name: PropTypes.string,
    full_address: PropTypes.string,
    working_hours: PropTypes.string,
  }).isRequired,
};

export default Store;
